module.exports = __webpack_public_path__ + "img/error.8344e381.png";